import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Event } from '@ifeng-fe/ui_base';
import { formatImage } from '@ifeng-fe/public_method';
import { handleAd } from '@ifeng-fe/ui_pc_ad';

class HotTopicList extends React.PureComponent {
    static propTypes = {
        hotRecommond: PropTypes.array,
        minScreen: PropTypes.bool,
    };

    render() {
        const { minScreen, hotRecommond } = this.props;
        const listItem = (item, index) => {
            const imgUrl = item?.thumbnails?.image?.[0]?.url && formatImage(item.thumbnails.image[0].url, 408, 230);

            return item.type && item.type === 'ad' ? (
                <li className={`${styles.listItem} ${minScreen ? styles.min_listItem : ''} ${styles.adDom}`} key={index} ref={item.ref} />
            ) : (
                <li className={`${styles.listItem} ${minScreen ? styles.min_listItem : ''}`} key={index}>
                    <a href={item.url} target="_blank">
                        <img src={imgUrl} alt={item.title} />
                        <i />
                        <em />
                        <strong className={styles.itemTitle}>{item.title}</strong>
                    </a>
                </li>
            );
        };

        return (
            <div className={`${styles.hotTopicList} ${minScreen ? styles.min_hotTopicList : ''}`}>
                <ul>
                    {hotRecommond && hotRecommond.length > 0
                        ? hotRecommond.map((item, index) => {
                              return listItem(item, index);
                          })
                        : null}
                </ul>
            </div>
        );
    }
}

class HotTopic extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        minScreen: PropTypes.bool,
        ad: PropTypes.object,
        hotRecommond: PropTypes.array,
    };

    state = {
        listData: this.props.content,
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { listData } = this.state;

            const refs = [];

            insertArr.forEach((item) => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                listData.splice(item, 0, { type: 'ad', ref });
            });

            replaceArr.forEach((item) => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                listData.splice(item, 1, { type: 'ad', ref });
            });

            const newListData = [...listData];

            this.setState({ listData: newListData }, () => {
                const dom = {};

                for (const ref of refs) {
                    dom[ref.index] = ref.ref.current;
                }

                adFn(dom);
            });
        }

        return;
    };

    insertAd = async (type) => {
        const { listData } = this.state;

        if (type === 'init') {
            try {
                this.event.trigger('init', { len: listData.length });
            } catch (e) {
                console.error(e);
            }
        }
    };

    async componentDidMount() {
        try {
            const { ad } = this.props;
            // 测试数据
            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         // event 为传入的 event 事件对象，用于广告方绑定事件
            //         // insert 为我们自定义的广告插入方法
            //         event.on('init', data => {
            //             console.log(data);
            //             // data 为我们触发方法时传参值
            //             const insertArr = [];

            //             const replaceArr = [3, 5];

            //             insert(insertArr, replaceArr, dom => {
            //                 console.log(dom);
            //             });
            //         });
            //     },
            // };

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert);
        } catch (e) {
            console.error(e);
        }

        await this.insertAd('init');
    }

    render() {
        const { minScreen, hotRecommond } = this.props;
        const { listData } = this.state;

        return (
            <section className={styles.hotTopic} aria-label="热播推荐">
                <div className={`${styles.title} ${minScreen ? styles.min_title : ''}`}>
                    <h2>热播推荐</h2>
                </div>
                {/* <Chip id="75179" type="recommend" title="视频播放页-热播推荐" groupName="正文"> */}
                <HotTopicList minScreen={minScreen} hotRecommond={hotRecommond} />
                {/* </Chip> */}
            </section>
        );
    }
}

export default errorBoundary(HotTopic);
